import { useDocumentTitleEntity } from '@components/DocumentTitle'
import { Localizable } from '@components/localizable/Localizable'
import Program from '@components/membership/program/Program'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  getProgramWithSlug,
  resetProgramQueryAndIds,
  selectProgramBySlug,
  setSelectedProgram,
  setSelectedProgramWithSlug,
} from '@store/membership/ProgramReducer'
import { SBIcon } from '@supplement-bacon/react-toolkit/components'
import { extractSectionFromPath } from '@supplement-bacon/react-toolkit/utils'
import { initialQuery } from '@supplement-bacon/sb-table-filters'
import { Card, Flex, Space, Tabs, TabsProps, Typography } from 'antd'
import { Content } from 'antd/es/layout/layout'
import { useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'

const { Title, Text } = Typography

export const ProgramDetailLayout: React.FC = () => {
  const { programSlug } = useParams()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const dispatch = useAppDispatch()
  const program = useAppSelector(selectProgramBySlug(programSlug ?? ''))
  useDocumentTitleEntity(program?.friendlyName)

  useEffect(() => {
    setSelectedKey(extractSectionFromPath(pathname, 5))
    dispatch(resetProgramQueryAndIds(initialQuery))
  }, [pathname])

  const [selectedKey, setSelectedKey] = useState<string>('generals')

  let items: TabsProps['items'] = [
    {
      key: 'informations',
      label: 'Informations',
    },
    {
      key: 'concierge',
      label: 'Concierge',
    },
    {
      key: 'design-branding',
      label: 'Design & branding',
    },
    {
      key: 'wallet-card',
      label: 'Wallet card',
    },
    {
      key: 'form-questions',
      label: 'Form questions',
    },
    {
      key: 'email-notifications',
      label: 'Email notifications',
    },
    {
      key: 'payment-settings',
      label: 'Payment settings',
    },
    {
      key: 'balance-and-credits',
      label: 'Balances and credits',
    },
  ]

  const fetchProgram = () => {
    if (!programSlug) {
      return
    }
    dispatch(getProgramWithSlug(programSlug))
      .then(() => {
        dispatch(setSelectedProgramWithSlug(programSlug))
      })
      .catch(() => {})
  }

  useEffect(() => {
    fetchProgram()
  }, [dispatch, programSlug])

  useEffect(() => {
    if (program) {
      dispatch(setSelectedProgram(program.id))
    }
  }, [program])

  if (!program) {
    return <></>
  }

  return (
    <Content>
      <Localizable>
        <Flex vertical gap={15} className="container-row mt-0b">
          <Flex vertical gap={10} className="w-full">
            <Card>
              <Flex justify="space-between" align="center">
                <Flex gap={15} align="center">
                  <Flex
                    align="center"
                    justify="center"
                    style={{
                      width: 40,
                      height: 40,
                      backgroundColor: program.primaryColor,
                      borderRadius: 8,
                      padding: 8,
                    }}
                  >
                    <Text
                      style={{
                        color: 'white',
                        fontSize: 22,
                      }}
                    >
                      <SBIcon name={'ContainerOutlined'} />
                    </Text>
                  </Flex>
                  <Flex vertical>
                    <Title className="m-0" level={4}>
                      {program.friendlyName}
                    </Title>
                    <Text type="secondary" copyable>
                      {program.frontendUrl}
                    </Text>
                  </Flex>
                </Flex>
                <Program.PasscodeTag model={program} />
              </Flex>
            </Card>
            <Space className="w-full space-between align-center">
              <Tabs
                activeKey={selectedKey}
                items={items}
                onChange={(key) => {
                  setSelectedKey(key)
                  navigate(key)
                }}
                tabBarStyle={{ marginBottom: 0 }}
              />
              <Localizable.LangSelector type="floating" />
            </Space>
          </Flex>
          <Flex vertical gap={32}>
            <Outlet />
          </Flex>
        </Flex>
      </Localizable>
    </Content>
  )
}
